<template>

    <div class="container-fluid p-0" v-show="!isInvalid">
        <div class="row m-0">
            <div class="col-12 p-2">
                <div class=" login-card  card login-dark">
                    <div  >
                        <div class="card-header">
                            <h4>Workpermit Details</h4>
                                                          
                                                            <span v-if="gatepass.check_out!=null" class="badge badge-pill badge-success text-white">
                                                                    Checked Out
                                                            </span>
                                                            <span v-else-if="gatepass.checkout_approval==1" class="badge badge-pill badge-warning text-white">
                                                                    Check Out Approved
                                                            </span>
                                                            <span v-else-if="gatepass.checkout_approval==2" class="badge badge-pill badge-warning text-white">
                                                                    Check Out Denied
                                                            </span>
                                                            <span v-else-if="gatepass.check_in!=null" class="badge badge-pill badge-info text-white">
                                                                    Checked In
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==0" class="badge badge-pill badge-warning text-white">
                                                                    Pending
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==1" class="badge badge-pill badge-success text-white">
                                                                    Accepted
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==2" class="badge badge-pill badge-danger text-white">
                                                                    Denied
                                                            </span>
                        </div>

                        <div class="card-body bg-white">
                            <div class="daterow" >
                                <span class="frommargin">From Date:{{ gatepass.fromdate }}</span>

                                <span class="tomargin">To Date:{{ gatepass.todate }}</span>
                                </div>
                            <div class="row">
                                <div class="col-12 text-center"  @click="show_img_modal('QR','QR Code')">
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                                <div class="col-4 ">
                                    <div class="avatar"  @click="show_img_modal(this.$hostname+'/writable/uploads/visitors/wp/'+(gatepass.image.replace(/^wp\//, '')),'User Image')"
                                    ><img alt="" style="width:100px;"  :src="this.$hostname+'/writable/uploads/visitors/wp/'+(gatepass.image.replace(/^wp\//, ''))" v-if="gatepass.image"></div>
                                </div>
                                <div class="col-8 ">
                                        <b>Name :</b>  {{ gatepass.name }}<br>
                                        <b>Phone No :</b>  {{ gatepass.contact }}<br>
                                        <b>Company Name :</b>  {{ gatepass.companyname }}<br> 
                                        <b>Address :</b>  {{ gatepass.address }}<br> 
                                </div>
                            </div>
                            <div class="col-12 mt-4 row"> 
                                <table>
                                    <!-- <tr class="bottomborder">
                                        <td><b>Purpose</b></td>
                                        <td>{{ gatepass.purpose }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Schedule Date</b></td>
                                        <td>{{ gatepass.schedule_date }}</td>
                                    </tr> -->
                                  
                                    <tr v-if="gatepass.meeting_room" class="bottomborder">
                                        <td><b>Meeting Schedule</b></td>
                                        <td>{{ gatepass.meeting_room }}</td>
                                    </tr> 
                                </table>
                             
                                   
                            </div>
                            <div class="form-group col-12 mt-4 ">
                              <lable class="col-3"> Visitor Sign</lable> &nbsp;&nbsp;&nbsp;&nbsp;
                              <lable class="col-3"> Employee Sign</lable>&nbsp;&nbsp;&nbsp;&nbsp;
                              <lable class="col-3"> Security Sign</lable>
                            </div> 







                        <div class="card-footer bg-white" v-if="scan_user && scan_user?.empdept==sd" >
                             <div v-if="isCheckoutGreater(gatepass.max_check_in,gatepass.max_check_out)">
                                    <button  class="btn btn-success btn-sm" @click="mark_checkin(gatepass.id,1)">Check In</button>
                            </div>
                            <div v-else-if="!isCheckoutGreater(gatepass.max_check_in,gatepass.max_check_out)">
                                <button  class="btn btn-danger btn-sm" @click="mark_checkin(gatepass.id,2)">Check Out</button>
                            </div>
                        </div> 
                        <button v-if="scan_user?.empdept==sd" class="btn btn-danger col-12" @click="this.$router.go(-1);">Go Back</button>
                        


                            <div class="table table-responsive">
                                <table class="table mt-3 mb-3 ">
                                    <thead>
                                        <tr>
                                            <th>SR</th>
                                            <!--<th>Date</th>-->
                                            <th>Check In</th>
                                            <th>Check Out</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index)  in  gatepasscheckin" >
                                            <td>{{ index+1 }} &nbsp;</td>
                                            <!--<td>{{ new Date(item.iddate).toLocaleDateString() }}&nbsp;&nbsp;</td>-->
                                            <td>{{ item.checkindate }}&nbsp;&nbsp;</td>
                                            <td>{{ item.checkoutdate }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div >
                            </div> 
                    </div>
                     
                </div>
            </div>
        </div>
    </div>
    <h2 v-show="isInvalid" style="
    height: 100vh;
    place-content: center;
    justify-self: anchor-center;
">Invalid Access</h2>
 <div class="modal fade" id="showingImg" tabindex="-1" role="dialog" aria-labelledby=" " aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{showingUserPic.title}}</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">

                            <img alt=""
                                :src="showingUserPic.src" class="img img-thumbnail"
                                /> 

                        </div>
                    </div>
                </div>
                <!--<div class="modal-footer">-->
                <!--    <div class="col-12">-->
                <!--        <button class="btn btn-primary" @click=""> </button>-->
                <!--    </div>-->
                <!--</div>-->
            </div>
        </div>
    </div>

        <audio  ref="checkoutPlayer" src="/sounds/checkout.mp3"></audio>
        <audio  ref="checkinPlayer"  src="/sounds/checkin.mp3"></audio>
        <audio  ref="invalidPlayer"  src="/sounds/invalid.mp3"></audio>
        <audio  ref="pendingPlayer"  src="/sounds/pending.mp3"></audio>

</template>
<style scoped>


.bottomborder{
    border-bottom: 1px solid grey;
}
/*.page-body {*/
/*    margin-left: 0 !important;*/
/*    margin-top: 0px;*/
/*}*/

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
    
     .table-responsive{
       width: 320 !important; 
    }


}
.avatar img{
    width: 100%; 
}
.login-card {
    min-height: 80vh;
}
.daterow{
    display: flex;
}
.tomargin{
    font-weight: bold;
    margin-left: 180px;
}
.frommargin{
    font-weight: bold;
}
</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'VisitorGatepassView',
    components: {

    },
    mounted() {
        if (this.$route.query.q) {
                this.getBasics(this.$route.query.q);
            }else
            window.location.href = this.$cur_host+'register';
            
             
    },
    data() {
        return {  
            gatepass: { "name": '', "firmname": '',"contact": '', "address": '',"purpose": '','designation':'','schedule_date':'','photo':'' } ,
            status:'',
            gatepasscheckin:[],
             scan_user:'',
             sd:0,
             showingUserPic:[],
             isInvalid:true,
        }
    },
    methods: { 
         isCheckoutGreater(checkInDate,checkOutDate) {
                    
                    if(checkInDate && !checkOutDate)
                        return false
                    else if(checkOutDate){
                        const inDate = new Date(checkInDate.replace(' ', 'T'));
                        const outDate = new Date(checkOutDate.replace(' ', 'T')); 
                        return outDate > inDate;
                    }else
                     return true;
                    
                },
        mark_checkin(passid,what) {
            var self = this;
            self.$swal({
                title: "Do You Want To "+((what==1)?'Check In':'Check Out')+" ?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('checkinworkpermit_QR', { passid: passid,what:what }).then(function (response) {
                        if(response.data.is==1){
                            self.gatepass= response.data.gatepass; 
                            self.gatepasscheckin= response.data.gatepasscheckin; 
                        }
                            self.$swal(response.data.message);
                            if(response.data?.sound && response.data.sound==1 && response.data.sound_file){
                                 if (self.$refs[response.data.sound_file])
                                    self.$refs[response.data.sound_file].play();
                                 else 
                                  console.warn(`Audio ref "${response.data.sound_file}" does not exist.`);
                            }
                             if(response.data.is==1){
                                 setTimeout(function () {
                                            window.location.replace(self.$cur_host + 'TabScan');
                                        }, 2000);
                             }
                    });
                }
            });

        },
        getBasics(token) {
            var self = this;
            axios.post('getworkpermitview',{token:token}).then(function (response) {
                if(response.data.is==0){
                    self.isInvalid=true;
                        return;
                }else 
                    self.isInvalid=false;
                    
                   self.gatepass= response.data.gatepass; 
                   self.gatepasscheckin= response.data.gatepasscheckin; 
                   self.scan_user= response.data.scan_user; 
                   self.sd= response.data.sd; 
                   self.getQrCode(self.gatepass.token);
                   
                   if(response.data?.is_repeat!=0){
                           if(self.scan_user.empdept == self.sd){
                               
                               if(self.isCheckoutGreater(self.gatepass.max_check_in,self.gatepass.max_check_out))
                                    self.mark_checkin(self.gatepass.id,1);
                                else 
                                    self.mark_checkin(self.gatepass.id,2);
                           
                       }
                   }
                window.scrollTo(0, 0);
            });
        },
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                  var url=this.$api_host+'wp?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          },
          show_img_modal(src,title){
              if(src=='QR'){
                    this.showingUserPic.src=this.$refs.qrcodeCanvas.toDataURL("image/png");;
                    this.showingUserPic.title=title;
                   $("#showingImg").modal("toggle");
              }else{
                  this.showingUserPic.src=src;
                  this.showingUserPic.title=title;
                  $("#showingImg").modal("toggle");
              }
               
          }

}
}
</script>
